import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import AgTable from '../../../Components/Table/AgTable';

export default function EvolucionVentasTiendaCumplimiento({ unidadEconomicaId, mesCierre, anio1, anio2 }) {

    let headers = [
        {
            headerName: 'Contrato',
            field: 'contratoId',
        },

        {
            headerName: 'Den. Contrato',
            field: 'contratoDenominacion',
        }
    ];


    for (let i = 1; i <= 12; i++) {
        let lenhtTemp = Utilities.getHeaderMonth(mesCierre, anio2, i);
        headers.push({
            headerName: Utilities.getHeaderMonth(mesCierre, anio1, i) + '/' + lenhtTemp.substring(lenhtTemp.length - 4),
            field: 'mes' + (i),
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data[`mes${i}`], true)}</>
            )
        });
    }

    return (
        <AgTable
            idContent={"EvolucionVentasTiendaCumplimiento " + unidadEconomicaId + " " + mesCierre + " " + anio1 + " " + anio2}
            apiService={Api.EvolucionVentasTiendaCumplimiento}
            setAuxData={null}
            header={headers}
            titleExcel={"EvolucionVentasTiendaCumplimiento - " + unidadEconomicaId + " " + mesCierre + " " + anio1 + " " + anio2}
            conditions={true}
            args={{
                unidadEconomicaId: unidadEconomicaId,
                mesCorte: mesCierre,
                anio1: (anio1 + 1),
                anio2: (anio2 + 1),
                token: useGetToken()
            }}
            hideFilter={false}
            paginationPageSize={8}
            rowHeight={40}
            useFlex={false}
        />
    )
}